import ErrorBoundary from 'components/utils/ErrorBoundary';
import React from 'react';
import ReactDom from 'react-dom';

import App from './src/App';

const rootElm = document.getElementById('react-register-info');

ReactDom.render(
	<ErrorBoundary preserveChildren>
		<App {...Yoderm.data}/>
	</ErrorBoundary>
	, rootElm);


if (module.hot) {
	module.hot.accept('./src/App',
		() => {
			const NextApp = require('./src/App');
			ReactDom.render(
				<NextApp {...Yoderm.data} />,
				rootElm);
		})
}
